<template>
    <DataTable :class="[ size ? 'p-datatable-' + size : '' ]" 
    :value="datas" 
    stripedRows 
    :paginator="pagination" 
    :rows="rows" 
    :responsiveLayout="responsiveLayout" 
    breakpoint="414px" 
    :showGridlines="false" 
    :resizableColumns="false" 
    columnResizeMode="fit" 
    selectionMode="single" 
    v-model:selection="current_row" 
    :scrollable="!!height.length" 
    :scrollHeight="height"
    :style="height?`height: ${height}`:''">
        <!-- 序号：分页不正确 -->
        <Column header="" headerStyle="width: 70px;" bodyStyle="text-align: center" v-if="showRank">
            <template #body="slotProps">
                {{slotProps.index + 1}}
            </template>
        </Column>
        <Column v-for="column in columns" :key="column.field_name"
            :field="column.field_name"
            :header="column.caption"
            :style="{
                flex: height.length && column.edit_width ? `0 0 ${column.edit_width}px` : '',
                width: !height.length && column.edit_width ? `${column.edit_width}px` : 'auto',
                'max-width': '200px'
            }"
            :bodyStyle="{
                'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'
            }"
            :sortable="sortable && ['string', 'number', 'date', 'boolean'].indexOf(column.data_type) > -1" 
            :frozen="!!column?.fixed?.length" 
            :alignFrozen="column?.fixed">
            <template #body="body">
                <tw-cell-edit :column="column" :dataRow="body.data" :readonly="readonly" @btnClick="btnClick"></tw-cell-edit>
            </template>
        </Column>

        <ColumnGroup type="footer" v-if="showSummary">
            <Row v-if="summaryColumns.length">
                <Column v-for="column in columns" :key="column.field_name" :footer="summaryColumns[0][column.field_name]"></Column>
            </Row>
        </ColumnGroup>

        <template #empty>
            <div :style="{
                'line-height': `calc(${height} - ${size === 'lg' ? '48px - 30px' : '42px - 24px'})`
            }">
                暂无数据
            </div>
        </template>
    </DataTable>
</template>

<script>
import { computed, watchEffect, ref } from 'vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import { formatNumber } from '../../utils/formatNumber'
import { formatDate } from '../../utils/formatDate'
import { calcSummary } from '../../utils/calcSummary'

export default {
    name: 'tw-grid-edit',
    components: {
        DataTable,
        Column,
        ColumnGroup,
        Row
    },
    setup(props, context) {
        const columns = computed(() => {
            return props.data_source && props.data_source.columns && props.data_source.columns.filter(el => {
                let visible = true
                // 需要注意如果无 visible 时也要显示，只有等于 False 时才不显示
                if (el.visible === false) {
                    visible = false
                } else {
                    // 如果指定分组，则只显示该分组的字段
                    if (props.group_name) {
                        visible = el.group_name === props.group_name
                    }
                }

                return visible
            }) || []
        })

        const datas = computed(() => {
            if (props.data_source && Array.isArray(props.data_source.datas)) {
                return props.data_source.datas.filter(item => item)
            } else {
                return []
            }
        })

        const showSummary = computed(() => {
            return columns.value.filter(el => !!el.summary_type).length !== 0
        })

        const summaryColumns = ref([])

        watchEffect(() => {
            if(showSummary.value){
                if (columns.value.length && datas.value.length) {
                    const _summary = {};

                    columns.value.forEach(column => {
                        _summary[column.field_name] = calcSummary(datas.value, column);
                    });
                    
                    summaryColumns.value = [_summary];
                }else{
                    summaryColumns.value = []
                }
            }
        })

        const current_row = computed({
            get() {
                return props.data_source.current
            },
            set(value){
                if(value){
                    const temp = props.data_source;
                    temp.current = value
                    context.emit('update:data_source', temp)
                }
            }
        })

        // 来自tw-cell-edit扩展按钮点击事件
        const btnClick = (obj) => {
            context.emit('btnClick', obj)
        }

        return {
            columns,
            datas,
            showSummary,
            current_row,
            btnClick,
            summaryColumns,
            formatNumber,
            formatDate
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        group_name: {
            type: String,
            default: ''
        },
        size: String,
        responsiveLayout: {
            type: String,
            default: 'scroll'
        },
        pagination: {
            type: Boolean,
            default: false
        },
        rows: {
            type: Number,
            default: 10
        },
        readonly: {
            type: Boolean,
            default: true
        },
        sortable: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: ''
        },
        showRank: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>

</style>